import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Addresses_ds_get_shipments_by_contactId_top1Service {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { contactId: number }): 
  Promise<{ result: { Id?: number, ContactId?: number, PaymentContactId?: number, ShipToContactId?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.contactId)) {
      $missingRequiredInParams.push('\'contactId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      contactId: number    }) {
        if(isNil($inParams.contactId)) {
          return true; 
        }
      return false;
    }
}
